const COLORS = {
    black: '#000000',
    white: '#FFFFFF',

    gray_900: '#232323',
    gray_800: '#3A3A3A',
    gray_700: '#575757',
    gray_600: '#7E7E7E',
    gray_500: '#BCBCBC',
    gray_400: '#D5D5D5',
    gray_300: '#E9E9E9',
    gray_200: '#F1F1F1',
    gray_100: '#F5F5F4',
    gray_50: '#FAFAF9',

    yellow_900: '#713F12',
    yellow_800: '#854D0E',
    yellow_700: '#A16207',
    yellow_600: '#CA8A04',
    yellow_500: '#EAB308',
    yellow_400: '#FACC15',
    yellow_300: '#FDE047',
    yellow_200: '#FEF08A',
    yellow_100: '#FEF9C3',
    yellow_50: '#FEFCE8',

    red_900: '#881337',
    red_800: '#9F1239',
    red_700: '#BE123C',
    red_600: '#E11D48',
    red_500: '#F43F5E',
    red_400: '#FB7185',
    red_300: '#FDA4AF',
    red_200: '#FECDD3',
    red_100: '#FFE4E6',
    red_50: '#FFF1F2',

    purple_900: '#6125F5',
    purple_800: '#7037F5',
    purple_700: '#7D4AF7',
    purple_600: '#895EF6',
    purple_500: '#9066F6',
    purple_400: '#A787F8',
    purple_300: '#BBA1F8',
    purple_200: '#D8C8FF',
    purple_100: '#EBE3FE',
    purple_50: '#FBF9FF',

    orange_900: '#7C2D12',
    orange_800: '#9A3412',
    orange_700: '#C2410C',
    orange_600: '#EA580C',
    orange_500: '#F97316',
    orange_400: '#FB923C',
    orange_300: '#FDBA74',
    orange_200: '#FED7AA',
    orange_100: '#FFEDD5',
    orange_50: '#FFF7ED',

    lime_900: '#365314',
    lime_800: '#3F6212',
    lime_700: '#4D7C0F',
    lime_500: '#84CC16',
    lime_600: '#65A30D',
    lime_400: '#A3E635',
    lime_300: '#BEF264',
    lime_200: '#D9F99D',
    lime_100: '#ECFCCB',
    lime_50: '#F7FEE7',

    green_900: '#064E3B',
    green_800: '#065F46',
    green_700: '#047857',
    green_600: '#059669',
    green_500: '#10B981',
    green_400: '#34D399',
    green_300: '#6EE7B7',
    green_200: '#A7F3D0',
    green_100: '#D1FAE5',
    green_50: '#ECFDF5',

    cyan_900: '#164E63',
    cyan_800: '#155E75',
    cyan_700: '#0E7490',
    cyan_600: '#0891B2',
    cyan_500: '#06B6D4',
    cyan_400: '#22D3EE',
    cyan_300: '#67E8F9',
    cyan_200: '#A5F3FC',
    cyan_100: '#CFFAFE',
    cyan_50: '#ECFEFF',

    blue_900: '#1E3A8A',
    blue_800: '#1E40AF',
    blue_700: '#1D4ED8',
    blue_600: '#2563EB',
    blue_500: '#3B82F6',
    blue_400: '#60A5FA',
    blue_300: '#93C5FD',
    blue_200: '#BFDBFE',
    blue_100: '#DBEAFE',
    blue_50: '#EFF6FF',

    google_blue: '#4C8DF6',
    google_blue_100: '#93C5FD',
    tiktok_pink: '#FE2C55',
    tiktok_pink_100: '#FDA4AF',
    instagram_orange: '#FF8A00',
    instagram_orange_100: '#FED7AA',
};

const breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};

export const theme = {
    bp: breakpoints,

    ...COLORS,
    gray_1: COLORS.black,
    gray_2: COLORS.gray_800,
    gray_3: COLORS.gray_600,
    gray_4: COLORS.gray_500,
    gray_5: COLORS.gray_300,
    gray_6: COLORS.gray_50,
    gray_7: COLORS.white,

    red_1: COLORS.red_500,
    red_2: COLORS.red_600,

    orange_1: COLORS.orange_400,
    orange_2: COLORS.orange_500,

    yellow_1: COLORS.yellow_300,
    yellow_2: COLORS.yellow_500,

    green_1: COLORS.green_600,
    green_2: COLORS.green_600,
    green_3: COLORS.green_300,

    purple_1: COLORS.purple_500,
    purple_2: COLORS.purple_700,
    purple_3: COLORS.purple_900,
    purple_4: COLORS.purple_200,
    purple_5: COLORS.purple_50,
    purple_6: COLORS.purple_50,
    purple_7: COLORS.purple_100,

    neutral_1: COLORS.black,
    neutral_2: COLORS.gray_900,
    neutral_3: COLORS.gray_700,
    neutral_4: COLORS.gray_600,
    neutral_5: COLORS.gray_400,
    neutral_6: COLORS.gray_500,
    neutral_7: COLORS.gray_200,
    neutral_7_rgb: '241, 241, 241',

    time_series_line_colors: [
        COLORS.purple_500,
        COLORS.yellow_500,
        COLORS.red_500,
        COLORS.blue_500,
        COLORS.lime_500,
        COLORS.purple_300,
        COLORS.red_300,
        COLORS.yellow_300,
        COLORS.blue_300,
        COLORS.lime_300,
    ],

    fontSize_xl: '56px',
    fontSize_lg: '36px',
    fontSize_md: '20px',
    fontSize_base: '16px',
    fontSize_3: '14px',
    fontSize_sm: '12px',
    fontSize_xs: '10px',

    fontThin: 100,
    fontLight: 200,
    fontRegular: 300,
    fontMedium: 400,
    fontSemiBold: 500,
    fontBold: 600,
    fontExtrabold: 700,
    fontBlack: 800,
    fontExtraBlack: 900,

    letterSpacing_xl: '3.2px',
    letterSpacing_lg: '2.75px',
    letterSpacing_md: '2.2px',
    letterSpacing_sm: '1.8px',
    letterSpacing_xs: '1.3px',

    style_primary: 'Montserrat, sans-serif',
    style_data: "'Roboto Mono', monospace",

    space_1: 2,
    space_2: 4,
    space_3: 6,
    space_4: 8,
    space_5: 10,
    space_6: 12,
    space_7: 14,
    space_8: 16,
    space_9: 20,
    space_10: 24,
    space_11: 32,
    space_12: 40,
    space_13: 48,
    space_14: 64,
    space_15: 80,
    space_16: 100,
    space_17: 120,

    // black
    box_shadow_1: '0 1px 4px rgba(0,0,0,0.2)',
    // light purple
    box_shadow_2: `0 2px 10px rgba(152,100,255,0.6)`,
    // big purple blob
    box_shadow_big: `0 2px 8px rgba(0,0,0,0.4), 0 0 10px rgba(152,100,255,0.4)`,

    borderRadius_sm: '2px',
    borderRadius_md: '3px',
    borderRadius_lg: '6px',

    // TRANSITIONS
    bezier: 'all .1s cubic-bezier(.71,-.46,.88,.6)',
    linear: 'all .1s linear',
    slowLinear: 'all .4s ease',

    overlay_white_hidden: 'rgba(250,250,250,0)',
    overlay_purple_hidden: 'rgba(152,100,250,0)',
    overlay_white_show: 'rgba(250,250,255,0.4)',
    overlay_white_radial:
        'radial-gradient(rgba(241,241,241, 0.3), rgba(0,0,0, 0.5))',
    overlay_white_linear_full:
        'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.6) 20%, rgba(255, 255, 255, 0.2) 100%)',
    overlay_white_linear:
        'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.7) 10%, rgba(255, 255, 255, 0.2) 25%, rgba(255, 255, 255, 0.0) 100%)',
    overlay_purple_linear:
        'linear-gradient(0deg, rgba(86, 0, 255, 1) 0%, rgba(86, 0, 255, 0.6) 30%, rgba(255, 255, 255, 0.2) 100%)',
    overlay_purple_show: 'rgba(152,100,255,0.4)',
    overlay_red_show: 'rgba(255,0,0,0.4)',
    overlay_black: 'rgba(0,0,0,0.5)',

    placeHolderShimmer: {
        '0%': {
            backgroundPosition: '-100% 0',
        },
        '100%': {
            backgroundPosition: '100% 0',
        },
    },
};
